/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Meta_TitleInputs */

const id_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari | egdata.app`)
};

const ms_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari | egdata.app`)
};

const da_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg | egdata.app`)
};

const de_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche | egdata.app`)
};

const en_us2_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search | egdata.app`)
};

const es_es2_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar | egdata.app`)
};

const es_mx2_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar | egdata.app`)
};

const fil_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap | egdata.app`)
};

const fr_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche | egdata.app`)
};

const it_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca | egdata.app`)
};

const hu_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés | egdata.app`)
};

const nl_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken | egdata.app`)
};

const no_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk | egdata.app`)
};

const pl_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj | egdata.app`)
};

const pt_br2_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar | egdata.app`)
};

const pt_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar | egdata.app`)
};

const ro_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Căutare | egdata.app`)
};

const fi_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haku | egdata.app`)
};

const sv_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök | egdata.app`)
};

const vi_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm | egdata.app`)
};

const tr_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara | egdata.app`)
};

const cs_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat | egdata.app`)
};

const bg_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене | egdata.app`)
};

const ru_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск | egdata.app`)
};

const uk_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук | egdata.app`)
};

const ar_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث | egdata.app`)
};

const hi_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज | egdata.app`)
};

const th_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา | egdata.app`)
};

const ja_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索 | egdata.app`)
};

const zh_cn2_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 | egdata.app`)
};

const zh_hant1_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋 | egdata.app`)
};

const ko_search_meta_title = /** @type {(inputs: Search_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색 | egdata.app`)
};

/**
* | output |
* | --- |
* | "Search \| egdata.app" |
*
* @param {Search_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_meta_title = /** @type {((inputs?: Search_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_meta_title(inputs)
	if (locale === "ms") return ms_search_meta_title(inputs)
	if (locale === "da") return da_search_meta_title(inputs)
	if (locale === "de") return de_search_meta_title(inputs)
	if (locale === "en-US") return en_us2_search_meta_title(inputs)
	if (locale === "es-ES") return es_es2_search_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_search_meta_title(inputs)
	if (locale === "fil") return fil_search_meta_title(inputs)
	if (locale === "fr") return fr_search_meta_title(inputs)
	if (locale === "it") return it_search_meta_title(inputs)
	if (locale === "hu") return hu_search_meta_title(inputs)
	if (locale === "nl") return nl_search_meta_title(inputs)
	if (locale === "no") return no_search_meta_title(inputs)
	if (locale === "pl") return pl_search_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_search_meta_title(inputs)
	if (locale === "pt") return pt_search_meta_title(inputs)
	if (locale === "ro") return ro_search_meta_title(inputs)
	if (locale === "fi") return fi_search_meta_title(inputs)
	if (locale === "sv") return sv_search_meta_title(inputs)
	if (locale === "vi") return vi_search_meta_title(inputs)
	if (locale === "tr") return tr_search_meta_title(inputs)
	if (locale === "cs") return cs_search_meta_title(inputs)
	if (locale === "bg") return bg_search_meta_title(inputs)
	if (locale === "ru") return ru_search_meta_title(inputs)
	if (locale === "uk") return uk_search_meta_title(inputs)
	if (locale === "ar") return ar_search_meta_title(inputs)
	if (locale === "hi") return hi_search_meta_title(inputs)
	if (locale === "th") return th_search_meta_title(inputs)
	if (locale === "ja") return ja_search_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_search_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_meta_title(inputs)
	return ko_search_meta_title(inputs)
});
export { search_meta_title as "search.meta.title" }